module.exports = __webpack_public_path__ + "static/img/coding.e25b481b.png";